import React, { useContext, useState } from "react";
import styled, { keyframes } from "styled-components";
import { DataContext } from "../../../app/ApiContext";
import PlanModal from "./GetPlanDurationModal";
import sendFirebaseEvent from "../../../analytics/FirebaseAnalytics";

const SubscriptionPage = () => {
  const { data } = useContext(DataContext);
  const plans = data?.data;
  console.log("plans", plans);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const formatToINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };
  const Staticplans = [
    {
      name: "Studio Plan",
      monthly: 1499,
      yearly: 14999,
      storage: "100 GB",
      features: {
        "Client App": true,
        "Proposal Tool": true,
        "Admin Dashboard": true,
        "Standard Support": true,
        "White-label Branding": false,
        "Team management": false,
        "Calendar management": false,
      },
    },
    {
      name: "Pro",
      monthly: 2999,
      yearly: 29999,
      storage: "300 GB",
      features: {
        "Client App": true,
        "Proposal Tool": true,
        "Admin Dashboard": true,
        "Priority Support": true,
        "Team management": true,
        "Calendar management": true,
        "White-label Branding": false,
      },
    },
    {
      name: "Business",
      monthly: 4999,
      yearly: 49999,
      storage: "1 TB",
      features: {
        "Client App": true,
        "Admin Dashboard": true,
        "Team management": true,
        "Calendar management": true,
        "Priority Support": true,
        "Proposal Tool": true,
        "White-label Branding": true,
      },
    },
  ];

  const getStaticPlan = (planTitle) =>
    Staticplans.find(
      (pl) =>
        pl.name === planTitle || pl.name.startsWith(planTitle + " ")
    );

  const getStaticPlanFeatures = (planTitle) =>
    getStaticPlan(planTitle)?.features ?? {};

  const visiblePlans =
    plans
      ?.filter((plan) => {
        const planTitle = plan.description?.split(" ")[0];
        return planTitle && getStaticPlan(planTitle);
      })
      ?.sort((a, b) => (a.offer_price || 0) - (b.offer_price || 0)) ?? [];
  console.log("visiblePlans", visiblePlans);
  console.log("plans", plans);
  return (
    <div >
      < PlanTitle > FLEXIBLE PRICING PLANS</PlanTitle >
      <PlansContainer>
        {visiblePlans.map((plan) => {
          const planTitle = plan.description.split(" ")[0];
          return (
            <PlanCard key={plan.id} $isPopular={planTitle === "Pro"}>
              <AnnualOfferTag>Save 17%</AnnualOfferTag>
              {planTitle === "Pro" && (
                <PopularTag>
                  <span className="star">★</span> Most Popular
                </PopularTag>
              )}
              <div className="text-3xl font-bold text-center uppercase linear-text">
                {planTitle}
              </div>
              {/* <Title>{plan.storage_size}</Title> */}
              <Price>
                <span className="text-black font-semibold">
                  {formatToINR(plan.offer_price * plan.plan_pack_duration)}
                </span>
                <span className="text-gray-500 text-sm">/Monthly</span>{" "}
                <span className="text-black font-semibold">
                  {formatToINR(plan.storage_price_per_year)}
                </span>
                <span className="text-gray-500 text-sm">/Yearly</span>
              </Price>
              {/* <div className="text-[#696969] text-[18px] font-semibold text-center">
                Team Members - <span className="">{plan.user_limit}</span>
              </div> */}
              <div className="text-[#696969] text-[18px] font-semibold text-center">
                {plan.storage_size}
              </div>
              <div
                style={{
                  background:
                    "linear-gradient(90deg, rgba(179, 179, 179, 0) 0%, #B3B3B3 50%, rgba(179, 179, 179, 0) 100%)",
                }}
                className="w-full h-[1px] my-2"
              ></div>
              {/* <Description>{plan.description}</Description> */}
              {Object.entries(getStaticPlanFeatures(planTitle)).map(
                ([key, value]) => {
                  return (
                    <Feature key={key}>
                      {value ? "✅" : "❌"} {key}
                    </Feature>
                  );
                })}
              {/* {planTitle === "Pro" && (
                <AddOnFeature>+ Add-on : White-labeling</AddOnFeature>
              )} */}
              {/* <Features>
                                <Feature>✅ Client App</Feature>
                                <Feature>{planTitle !== "Pro" ? "✅" : "❌"} Proposal Tool</Feature>
                                <Feature>✅ Admin Dashboard</Feature>
                                <Feature>{planTitle === "Growth" || planTitle === "Elite" ? "✅" : "❌"} Payout Tracker</Feature>
                                <Feature>{planTitle === "Elite" ? "✅" : "❌"} White-label Branding</Feature>
                                <Feature>{planTitle !== "Starter" ? "✅" : "❌"} Team management</Feature>
                                <Feature>{planTitle !== "Starter" ? "✅" : "❌"} Calendar management</Feature>
                                <Feature>{planTitle !== "Starter" || planTitle !== "Pro" ? "✅" : "❌"} Priority Support</Feature>
                                <Feature>{planTitle === "Elite" || planTitle === "Growth" ? "✅" : "❌"} Website</Feature>
                                {/* <Feature>✅ {plan.project_limit} Albums</Feature>
                                <Feature>✅ Share to {plan.user_limit} People</Feature>
                                <Feature>{!plan.event_management ? "❌" : "✅"} Event Scheduling</Feature>
                                <Feature>{!plan.packages ? "❌" : "✅"} Studio Packages</Feature>
                                <Feature>{!plan.user_form ? "❌" : "✅"} Customer Event Management</Feature> */}
              {/* </Features> */}
              <Button
                isCurrent={plan.isCurrent}
                onClick={() => {
                  setSelectedPlan(plan);
                  sendFirebaseEvent(
                    "Subscription",
                    "Choose Plan",
                    "click",
                    "click on choose plan"
                  );
                }}
              >
                {plan.isCurrent ? "Current Plan" : "Choose Plan"}
              </Button>
            </PlanCard>
          );
        })}
        {/* Modal Component */}
        {selectedPlan && (
          <PlanModal
            plan={selectedPlan}
            onClose={() => setSelectedPlan(null)}
            formatToINR={formatToINR}
          />
        )}
      </PlansContainer>
    </div >
  );
};

export default SubscriptionPage;

const PlanTitle = styled.div`
  font-size: 4rem;
  font-weight: 700;
  margin-top: 6rem;
  text-align: center;
`;

const PlansContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 4rem;
  padding: 2rem;
  margin-top: 1rem;
`;

// ✨ floating animation
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
`;

const PlanCard = styled.div`
  background: #ffffff;
  color: #a720b9;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.25);
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.3s ease;
  cursor: pointer;
  animation: ${float} 6s ease-in-out infinite;
  position: relative;
  ${(props) =>
    props.$isPopular &&
    `
    border: 2px solid transparent;
    background: linear-gradient(white, white) padding-box,
      linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%) border-box;
  `}

  &:hover {
    transform: translateY(-10px) scale(1.03);
  }
`;

const PopularTag = styled.div`
  width: 100%;
  margin-top:-50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  align-self: center;
  margin-bottom: 0.5rem;
  padding: 0.35rem 0.75rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%);
  border-radius: 10px;
  .star {
    font-size: 1rem;
  }
`;

const AnnualOfferTag = styled.div`
  position: absolute;
  top: 1.95rem;
  right: 0.75rem;
  padding: 0.4rem 0.65rem;
  font-size: 0.8rem;
  font-weight: 700;
  color: #fff;
  background: rgba(167, 32, 185, 0.95);
  border-radius: 10px;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(167, 32, 185, 0.35);
`;

const Price = styled.p`
  font-size: 1.5rem;
  margin: 0.5rem 0;
  text-align: center;
`;

const Feature = styled.li`
  margin: 0.5rem 0;
  font-size: 1.2rem;
  color: #696969;
  transition: transform 0.2s;
  list-style-type: none;
  padding-left: 0;

  &:hover {
    transform: translateX(5px);
    color: #000;
  }
`;

const Button = styled.button`
  background: ${(props) =>
    props.isCurrent
      ? "linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%)"
      : "linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%)"};
  border: none;
  border-radius: 100px;
  color: white;
  padding: 0.8rem 1.2rem;
  cursor: pointer;
  font-size: 1.4rem;
  margin-top: auto;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.08);
  }
`;
